export default __webpack_public_path__ + "img/2c22e1cff70b4056352f2a79a42415ad.svg";